<template>
  <div class="list-page-container">
    <div class="breadcrumbs">桥弘学院</div>
    <div class="header-button">
      <el-button type="success" icon="el-icon-document-add" @click="addArticles()">新增</el-button>
    </div>
    <div class="list-page-wrap">
      <!-- 顶部操作栏 -->
      <div class="list-page-heaser">
        <el-form ref="searchForm" class="header-search" :model="searchData" @keydown.enter.native="searchSubmit">
          <el-form-item label="标题" prop="title">
            <el-input v-model="searchData.title" clearable></el-input>
          </el-form-item>
          <el-form-item label="类型" prop="type_id">
            <el-select v-model="searchData.type_id" placeholder="请选择">
              <el-option v-for="item in dataDict.ACADEMY_TYPE" :key="item.value" :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分类" prop="category_id">
            <el-select v-model="searchData.category_id" placeholder="请选择">
              <el-option v-for="item in typeList" :key="item.label" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="success" icon="el-icon-search" @click="searchSubmit()">查询</el-button>
            <el-button @click="resetSearch()">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 列表数据 -->
      <div class="list-page-table">
        <custom-table ref="customTableRef" :data="tableData" :columns="columns" :pagination="pagination"
          :height="tableHeight" row-key="seed_id" @sort-change="handleSortChange"
          @selection-change="handleSelectionChange" @current-page-change="handleCurrentChange"
          @size-change="handleSizeChange">
          <!-- 类型 -->
          <template #type="{ row }">
            <div class="actions-btn">
              <div class="type-tag"
                :class="{ 'type-tag--video': row.type === '视频', 'type-tag--qa': row.type === 'Q&A' }"
                @click="handleTypeCellClick(row)">
                <Icon :name="getIconName(row.type)" class="type-tag__icon" />
                <span class="type-tag__text">{{ getTagName(row.type) }}</span>
              </div>
            </div>
          </template>
          <!-- 分类 -->
          <template #category="{ row }">
            <div class="type-tag">
              <span class="type-tag__text">{{ row.category }}</span>
            </div>
          </template>
          <!-- 提交时间 -->
          <template #created_at="{ row }">
            {{ formatDateTime(row.created_at) }}
          </template>
          <!-- 操作栏 -->
          <template #actions="{ row }">
            <span class="actions-btn">
              <el-tooltip content="编辑" placement="top" class="table-btn"><i @click="editRow(row)"
                  class="el-icon-edit-outline"></i></el-tooltip>
              <el-tooltip content="删除" placement="top" class="table-btn"><i @click="deleteListRow(row)"
                  class="el-icon-delete"></i></el-tooltip>
            </span>
          </template>
        </custom-table>
      </div>
    </div>
    <el-dialog :title="addArticlesTitle" width="1000px" :append-to-body="true" :close-on-click-modal="false"
      :visible.sync="addArticlesVisible" @closed="closeAddArticlesDialog()">
      <el-form ref="addArticlesForm" :model="addArticlesData" label-position="top">
        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item label="内容类型" prop="type_id">
              <el-select v-model="addArticlesData.type_id" placeholder="请选择">
                <el-option v-for="item in dataDict.ACADEMY_TYPE" :key="item.value" :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="标题" prop="title">
              <el-input v-model="addArticlesData.title" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="分类" prop="category_id">
              <el-select v-model="addArticlesData.category_id" placeholder="请选择">
                <el-option v-for="item in typeList" :key="item.label" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="摘要" prop="summary">
              <el-input v-model="addArticlesData.summary" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col v-if="addArticlesData.type_id === 2" :span="12">
            <el-form-item label="视频" prop="video">
              <el-upload class="video-upload" :action="uploadUrl" :file-list="videoFileList"
                :accept="'video/mp4,video/avi,video/mkv,video/quicktime'" :on-success="handleVideoSuccess"
                :before-upload="beforeVideoUpload" :on-remove="handleVideoRemove">
                <el-button size="small" type="success" icon="el-icon-upload2">点击上传</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col v-if="addArticlesData.type_id === 2" :span="12">
            <el-form-item label="视频缩略图" prop="video_thumb">
              <el-upload class="avatar-uploader" drag :show-file-list="false" :action="uploadUrl"
                :on-success="handleImageSuccess" :before-upload="beforeImageUpload">
                <img v-if="addArticlesData.video_thumb" :src="imageUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="内容" prop="content">
              <el-input v-model="addArticlesData.content" clearable></el-input>
              <!-- 富文本编辑器 -->
              <!-- <quill-editor v-model="addArticlesData.content" :options="quillOptions" class="quill-editor" /> -->
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item class="text-right">
              <el-button @click="addArticlesVisible = false">取消</el-button>
              <el-button type="success" @click="addArticlesSubmit()">保存</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
    <!-- 视频播放弹窗 -->
    <el-dialog title="视频播放" :visible.sync="videoDialogVisible" width="1115px" center :close-on-click-modal="false">
      <div class="video-container">
        <video v-if="currentVideoUrl" height="600" :key="currentVideoUrl" controls>
          <source :src="`${imgUrl}${currentVideoUrl}`" :poster="`${imgUrl}${currentVideoPoster}`" type="video/mp4">
        </video>
        <el-empty v-else description="暂无视频资源"></el-empty>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import apis from '@/api'
import listMixin from '@/mixins/listMixin'
import CustomTable from '@/components/custom-table.vue'
import * as DICT from '@/utils/dict/fieldDictionary'
export default {
  name: 'Articles',
  mixins: [listMixin],
  components: {
    CustomTable
  },
  data() {
    return {
      dataDict: DICT,
      typeList: [],
      overview: {},
      imgUrl: `${this.GLOBAL_ENV.VUE_APP_BASE_DOMAIN}${apis.OSS_GET.url}`,
      imageUrl: '',
      addArticlesTitle: '新建内容',
      addArticlesVisible: false,
      addArticlesData: {
        id: '',
        type_id: '',
        category_id: '',
        title: '',
        summary: '',
        content: '',
        video: '',
        video_thumb: '',
        created_at: ''
      },
      addArticlesRules: {
      },
      // 列表相关数据
      searchData: {
        type_id: null,
        category_id: null,
        title: ''
      },
      columns: [
        { label: '类型', prop: 'type', width: '120' },
        { label: '标题', prop: 'title', width: '350' },
        { label: '分类', prop: 'category', width: '120' },
        { label: '摘要', prop: 'summary' },
        { label: '发布日期', prop: 'created_at', width: '140' },
        { label: '操作', prop: 'actions', width: '140', align: 'center' }
      ],
      queryListApi: apis.QUERY_ARTICLES_LIST,
      deleteListParams: {
        api: apis.DELETE_ARTICLES,
        id: 'id'
      },
      videoFileList: [],
      uploadUrl: `${this.GLOBAL_ENV.VUE_APP_BASE_DOMAIN}${apis.OSS_UPLOAD.url}?token=${localStorage.getItem('token')}`,
      videoDialogVisible: false, // 视频弹窗显隐控制
      currentVideoUrl: '', // 当前播放视频地址
      currentVideoPoster: '', // 视频封面地址
      quillOptions: {
        theme: 'snow', // 主流可视化主题（带工具栏+编辑区分离）
        modules: {
          // 工具栏配置：保留常用功能，避免冗余
          toolbar: [
            // 基础文本格式
            ['bold', 'italic', 'underline', 'strike'], // 加粗、斜体、下划线、删除线
            ['blockquote', 'code-block'], // 引用、代码块
            // 列表与对齐
            [{ list: 'ordered' }, { list: 'bullet' }], // 有序列表、无序列表
            [{ align: [] }], // 左对齐、居中、右对齐、两端对齐
            // 字体样式
            [{ size: ['small', false, 'large', 'huge'] }], // 字体大小
            [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题层级
            // 颜色控制
            [{ color: [] }, { background: [] }], // 文字颜色、背景色
            // 链接与图片（核心功能）
            ['link', 'image'],
            // 清除格式
            ['clean']
          ],
          // 历史记录：支持撤销/重做（默认开启，配置参数优化）
          history: {
            delay: 1000, // 保存历史记录的时间间隔（ms）
            maxStack: 50, // 最大撤销步数
            userOnly: false // 是否仅记录用户操作（false 包含程序修改）
          }
        },
        // 关键配置：指定滚动容器为编辑区自身
        scrollingContainer: '.ql-editor', // 关键：指定滚动容器
        // 编辑器基础配置
        placeholder: '请输入内容（支持富文本格式）',
        readOnly: false, // 是否只读（编辑模式为false，预览模式为true）
        // 格式限制：允许的HTML标签（防止恶意代码注入）
        formats: [
          'bold', 'italic', 'underline', 'strike',
          'blockquote', 'code-block',
          'list', 'bullet', 'ordered',
          'align', 'size', 'header',
          'color', 'background',
          'link', 'image',
          'table', 'mergecells', 'splitcells'
        ],
        // 自定义样式（适配Element UI表单）
        bounds: document.body // 工具栏弹出边界（避免超出可视区域）
      }
    }
  },
  mounted() {
    this.queryType()
  },
  methods: {
    addArticles() {
      this.addArticlesTitle = '新增内容'
      this.addArticlesVisible = true
    },
    addArticlesSubmit() {
      this.$refs.addArticlesForm.validate((valid) => {
        if (!valid) {
          return false
        }

        console.log(this.addArticlesData)
        let request = {}
        if (this.addArticlesData.id) {
          request = {
            url: '/api/v1/admin/knowledge_base/articles/' + this.addArticlesData.id,
            method: 'put',
            disableSuccessMsg: true,
            disableErrorMsg: false,
            params: {
              ...this.addArticlesData
            }
          }
        } else {
          request = {
            ...apis.SAVE_ARTICLES,
            params: {
              ...this.addArticlesData
            }
          }
        }
        this.$request(request)
          .asyncThen(
            (resp) => {
              if (resp.rst === 200) {
                this.queryListData()
                this.addArticlesVisible = false
              }
            },
            (err) => {
              console.error(err)
            }
          )
          .asyncErrorCatch((err) => {
            console.error('额外错误处理:', err)
          })
      })
    },
    editRow(row) {
      console.log('编辑行：', row)
      this.addArticlesTitle = '编辑内容'
      this.addArticlesVisible = true
      // 映射行数据到对话框表单，并自动选中对应状态按钮
      this.addArticlesData = {
        id: row.id,
        type_id: row.type_id,
        category_id: row.category_id,
        title: row.title,
        summary: row.summary,
        content: row.content,
        video: row.video,
        video_thumb: row.video_thumb,
        created_at: row.created_at
      }
      this.imageUrl = `${this.GLOBAL_ENV.VUE_APP_BASE_DOMAIN}${apis.OSS_GET.url}${row.video_thumb}`
    },
    closeAddArticlesDialog() {
      this.addArticlesData = {
        id: '',
        type_id: '',
        category_id: '',
        title: '',
        summary: '',
        content: '',
        video: '',
        video_thumb: '',
        created_at: ''
      }
      this.videoFileList = []
      this.$nextTick(() => {
        this.$refs.addArticlesForm.clearValidate()
      })
    },
    formatDateTime(timestamp) {
      if (!timestamp) return ''
      // 注意：你的数据是10位秒级时间戳，需要乘以1000转换成毫秒
      const date = new Date(timestamp * 1000)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    queryType() {
      this.typeList = []
      const request = {
        ...apis.QUERY_ARTICLES_OVERVIEW,
        params: {
        }
      }
      this.$request(request)
        .asyncThen(
          (resp) => {
            if (resp.rst === 200) {
              this.typeList = resp.data
            }
          },
          (err) => {
            console.error(err)
          }
        )
        .asyncErrorCatch((err) => {
          console.error('额外错误处理:', err)
        })
    },
    // 根据类型返回图标类名
    getIconName(type) {
      let a = type === '视频' ? 'video' : 'qa'
      return a
    },
    // 根据类型返回标签名称
    getTagName(type) {
      let b = type === '视频' ? '视频' : 'Q&A'
      console.log(b)
      return b
    },
    handleTypeCellClick(row) {
      console.log('点击')
      console.log(row)
      if (row.type === '视频') {
        // 调用视频播放方法
        this.videoDialogVisible = true
        this.currentVideoUrl = row.video
        this.currentVideoPoster = row.video_thumb
      }
    },
    handleVideoSuccess(res, file, fileList) {
      console.log(res)
      this.addArticlesData.video = res.data.id
      this.videoFileList = [file]
    },
    beforeVideoUpload(file) {
      const isVideo = file.type.startsWith('video/')
      if (!isVideo) {
        this.$message.error('请上传视频文件')
        return false
      }
      return true
    },
    handleVideoRemove(file, fileList) {
      this.addArticlesData.video = this.addArticlesData.video.filter(element => element.object_id !== file.uid)
      this.videoFileList = fileList
      console.log(this.addArticlesData.video)
    },
    handleImageSuccess(res, file) {
      this.imageUrl = `${this.GLOBAL_ENV.VUE_APP_BASE_DOMAIN}${apis.OSS_GET.url}${res.data.id}`
      this.addArticlesData.video_thumb = res.data.id
    },
    beforeImageUpload(file) {
      const isImg = ['image/jpeg', 'image/png'].includes(file.type)

      if (!isImg) {
        this.$message.error('只能上传图片格式!')
      }
      return isImg
    }
  }
}
</script>

<style scoped>
.el-select {
  width: 100%;
}

/* 视频类型标签 */
.type-tag--video {
  background-color: #AD46FF;
  color: #FFFFFF;
}

/* Q&A类型标签 */
.type-tag--qa {
  background-color: #fff;
  color: #0A0A0A;
}

/* 标签悬停效果 */
.type-tag:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

.type-tag__icon {
  font-size: 14px;
  margin: 0 8px 4px 8px;
}

.type-tag__text {
  line-height: 2;
}

.detail-item {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}

.video-container {
  display: flex;
  justify-content: center;
  /* 水平居中 */
  align-items: center;
  /* 垂直居中（可选，使视频在容器中垂直居中） */
  width: 100%;
  padding: 20px 0;
  /* 上下留白，提升视觉效果 */
}

/* 确保视频不超出容器宽度（适配小屏幕） */
.video-container video {
  max-width: 100%;
  /* 防止视频过宽溢出弹窗 */
  object-fit: contain;
  /* 保持视频比例，不拉伸 */
}

/* 编辑器整体容器 */
.quill-editor {
  width: 100%;
  height: 250px !important;
}

::v-deep .ql-container {
  height: calc(100% - 42px);
  box-sizing: border-box !important;
}

/* 视频缩略图上传区域样式 */
::v-deep .avatar-uploader .el-upload-dragger {
  width: 140px !important;
  height: 80px !important;
}

/* 缩略图图标样式 */
.avatar-uploader-icon {
  font-size: 24px;
  color: #8c939d;
  width: 100%;
  height: 100%;
  line-height: 80px;
  text-align: center;
}

/* 缩略图图片样式 */
.avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.table-btn {
  width: 38px;
  height: 32px;
  align-content: center;
  border: 0.8px solid #0000001A;
  border-radius: 8px;
}
</style>
